import { Storage } from "aws-amplify";
import { Interview, InterviewType } from "types/graphqlapi";
import * as Yup from "yup";

export const makePinCode = (): string => {
  return (Math.floor(Math.random() * 900000) + 100000).toString();
};

export const getYMDStr = (date: Date): string => {
  const Y = date.getFullYear();
  const M = `00${date.getMonth() + 1}`.slice(-2);
  const D = `00${date.getDate()}`.slice(-2);

  return `${Y}-${M}-${D}`;
};

export const getSlashDate = (date: Date): string => {
  const Y = date.getFullYear();
  const M = `00${date.getMonth() + 1}`.slice(-2);
  const D = `00${date.getDate()}`.slice(-2);
  const h = `00${date.getHours()}`.slice(-2);
  const m = `00${date.getMinutes()}`.slice(-2);

  return `${Y}/${M}/${D} ${h}:${m}`;
};

export const getDisplayYMD = (date: Date): string => {
  const Y = date.getFullYear();
  const M = `00${date.getMonth() + 1}`.slice(-2);
  const D = `00${date.getDate()}`.slice(-2);
  const day_arr = ["日", "月", "火", "水", "木", "金", "土"];
  const DDD = day_arr[date.getDay()];

  return `${Y}/${M}/${D} (${DDD})`;
};

export const getDisplayYMDhm = (date: Date): string => {
  const Y = date.getFullYear();
  const M = `00${date.getMonth() + 1}`.slice(-2);
  const D = `00${date.getDate()}`.slice(-2);

  const day_arr = ["日", "月", "火", "水", "木", "金", "土"];
  const DDD = day_arr[date.getDay()];

  const h = `00${date.getHours()}`.slice(-2);
  const m = `00${date.getMinutes()}`.slice(-2);

  return `${Y}/${M}/${D} (${DDD}) ${h}:${m}`;
};

export const getBotChatDate = (date: Date): string => {
  const thisYear = new Date().getFullYear();
  const Y = date.getFullYear();
  const M = `00${date.getMonth() + 1}`.slice(-2);
  const D = `00${date.getDate()}`.slice(-2);
  const day_arr = ["日", "月", "火", "水", "木", "金", "土"];
  const DDD = day_arr[date.getDay()];

  return `${thisYear !== Y ? `${Y}/` : ""}${M}/${D}(${DDD})`;
};

export const getDisplayMD = (date: Date): string => {
  const M = `${date.getMonth() + 1}`.slice(-2);
  const D = `${date.getDate()}`.slice(-2);
  const day_arr = ["日", "月", "火", "水", "木", "金", "土"];
  const DDD = day_arr[date.getDay()];

  return `${M}月${D}日(${DDD})`;
};

/* DBに登録されているdateを画面に表示するためのフォーマット */
export const formatDateForDisplay = (str: string | null | undefined) => {
  if (str === null || str === undefined) return str;
  const list = str.split("-");
  const formattedMonth = list[1]?.replace(/^0+/, "");
  const formatDay = list[2]?.replace(/^0+/, "");
  return `${list[0] || ""}/${formattedMonth || ""}/${formatDay || ""}`;
};

export const getDisplayTermInterviewYMD = (
  startDate: string,
  startTime: string,
  endDate: string,
  endTime: string
): string => {
  return startDate === endDate
    ? `${getDisplayYMD(new Date(startDate))} ${startTime} ～ ${endTime}`
    : `${getDisplayYMD(new Date(startDate))} ${startTime} ～ ${getDisplayYMD(
        new Date(endDate)
      )} ${endTime}`;
};

export const getInterviewUrl = (uuid: string): string => {
  return `${
    process.env.REACT_APP_INTERVIEW_URL_DOMAIN
  }/entry?i=${uuid.replaceAll("-", "")}`;
};

export const getModeratorInterviewUrl = (
  userId: string,
  interviewId: string
): string => {
  return `${
    process.env.REACT_APP_INTERVIEW_URL_DOMAIN
  }/entry?i=${userId.replaceAll("-", "")}&cr=${interviewId.replaceAll(
    "-",
    ""
  )}`;
};

export const getTestInterviewUrl = (uuid: string): string => {
  return `${
    process.env.REACT_APP_MEETING_URL_DOMAIN
  }/testentry?i=${uuid.replaceAll("-", "")}`;
};

export const getRoleName = (role: string): string => {
  switch (role) {
    case "ADMINISTRATOR":
      return "アドミニストレーター";
    case "ASMARQUSER":
      return "アスマークユーザー";
    case "GROUPMANAGER":
      return "グループマネージャー";
    case "GROUPUSER":
      return "グループユーザー";
    default:
      return "";
  }
};

export const getS3Url = (
  groupId: string,
  interview: Interview,
  fileName: string
): string => {
  return (
    groupId + "/" + interview.subject_id + "/" + interview.id + "/" + fileName
  );
};

export const gethhmmStr = (date: Date): string => {
  const h = `00${date.getHours()}`.slice(-2);
  const m = `00${date.getMinutes()}`.slice(-2);

  return `${h}:${m}`;
};

export const getStorageOutput = async (
  key: string
): Promise<string | undefined> => {
  try {
    const result = await Storage.get(key);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getFileProperties = async (key: string) => {
  try {
    const result = await Storage.getProperties(key);
    return result;
  } catch (error) {
    console.error("Error ", error);
  }
};

export const isToday = (startDate: string): boolean => {
  const now = new Date();
  const today = `${now.getFullYear()}-${("00" + (now.getMonth() + 1)).slice(
    -2
  )}-${("00" + now.getDate()).slice(-2)}`;
  return startDate === today;
};

export const isOnGoing = (
  scheduledStartDate: string | null | undefined,
  scheduledEndDate: string | null | undefined,
  actualEndDate: string | null | undefined
): boolean => {
  if (!scheduledStartDate || !scheduledEndDate) return false;
  const now = new Date();
  const today = `${now.getFullYear()}-${("00" + (now.getMonth() + 1)).slice(
    -2
  )}-${("00" + now.getDate()).slice(-2)}`;

  return (
    !actualEndDate && scheduledStartDate <= today && today <= scheduledEndDate
  );
};

export const getEndDate = (
  startDate: Date,
  startTime: string,
  minutes: number
) => {
  const startDateTime = new Date(`${getYMDStr(startDate)} ${startTime}`);
  const endDateTime = new Date(
    startDateTime.setMinutes(startDateTime.getMinutes() + minutes)
  );
  const endDate = getYMDStr(endDateTime);
  return endDate;
};

export const getEndTime = (
  startDate: Date,
  startTime: string,
  minutes: number
) => {
  const startDateTime = new Date(`${getYMDStr(startDate)} ${startTime}`);
  const endDateTime = new Date(
    startDateTime.setMinutes(startDateTime.getMinutes() + minutes)
  );
  const endTime = `${endDateTime.toTimeString().split(" ")[0].split(":")[0]}:${
    endDateTime.toTimeString().split(" ")[0].split(":")[1]
  }`;
  return endTime;
};

export const getInterviewMinutes = (
  startDate: string,
  startTime: string,
  endDate: string,
  endTime: string
) => {
  const startDateTime = new Date(`${startDate} ${startTime}`);
  const endDateTime = new Date(`${endDate} ${endTime}`);

  const diff = endDateTime.getTime() - startDateTime.getTime();
  const interviewMinutes = Math.floor(diff / 1000 / 60);

  return Number(interviewMinutes);
};

export const InterviewTypeTextMapper = (interviewType: InterviewType) => {
  switch (interviewType) {
    case InterviewType.TERM:
      return "期間指定";
    case InterviewType.ONE_TIME:
      return "ワンタイム";
    default:
      return "";
  }
};

export const isInterviewStarted = (interview?: Interview) => {
  if (!interview) return false;
  if (interview.interview_type === InterviewType.TERM) {
    if (!interview.scheduled_start_date || !interview.scheduled_start_time)
      return false;

    const now = new Date(Date.now());
    const dateTime = new Date(
      `${interview.scheduled_start_date}T${interview.scheduled_start_time}`
    );

    return now.getTime() > dateTime.getTime();
  } else {
    return interview.actual_start_date ? true : false;
  }
};

export const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const formattedTime = `${minutes
    .toString()
    .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;

  return formattedTime;
};

export const formatDateCompact = (date: Date) => {
  const year = String(date.getFullYear()).slice(-2); // 2桁の年
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0埋めされた2桁の月
  const day = String(date.getDate()).padStart(2, "0"); // 0埋めされた2桁の日
  const hour = String(date.getHours()).padStart(2, "0"); // 0埋めされた2桁の時
  const minutes = String(date.getMinutes()).padStart(2, "0"); // 0埋めされた2桁の分

  const formattedString = `${year}${month}${day}${hour}${minutes}`;
  return formattedString;
};

export const getFileExtension = (filePath: string): string => {
  // ファイルパスから最後のドットの位置を取得
  const lastDotIndex: number = filePath.lastIndexOf(".");
  // ドットが見つかった場合、それ以降の文字列を取得して返す（拡張子）
  if (lastDotIndex !== -1) {
    return filePath.slice(lastDotIndex + 1);
  } else {
    // ドットが見つからなかった場合は拡張子なしとして空文字列を返す
    return "";
  }
};

export const formatFileSize = (fileSizeInBytes?: number) => {
  if (fileSizeInBytes === undefined) return "";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let size = fileSizeInBytes;
  let unitIndex = 0;

  while (size >= 1000 && unitIndex < units.length - 1) {
    size /= 1000;
    unitIndex++;
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`;
};

export const isInvalidEmail = async (email: string) => {
  const emailSchema = Yup.string().email();
  try {
    await emailSchema.validate(email);
    return false;
  } catch (error) {
    return true;
  }
};
